import * as React from 'react'
import { useEffect } from 'react'

import { useHandlers } from './hooks'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import {
  navIconSize,
  NavItem,
  navItemTextStyle,
  navItemTileStyle,
  NavTooltip,
} from '@user/components/App/SideNav'
import { useSelector } from 'react-redux'
import { selectOverDueActivitiesCount } from '@user/features/Activity/store'
import Badge from '@mui/material/Badge/Badge'
import { useFetchOverdueActivitiesCount } from '@user/features/Activity/hooks/useFetchOverdueActivitiesCount'
import badgeStyles from '@mui/material/Badge/badgeClasses'

export type Props = {
  onBatchContentFetched: (count: number) => void
  expanded: boolean
}

export function ActivitySummaryButton({
  onBatchContentFetched,
  expanded,
}: Props) {
  const { onClick } = useHandlers()
  const loading = useFetchOverdueActivitiesCount()

  const { overdueCount } = useSelector(selectOverDueActivitiesCount)
  const badgeContent = loading !== 'loading' ? overdueCount : 0

  useEffect(() => {
    if (badgeContent > 0) {
      onBatchContentFetched(badgeContent)
    }
  }, [badgeContent, onBatchContentFetched])

  return (
    <NavTooltip label="Activity Summary" expanded={expanded}>
      <NavItem
        onClick={onClick}
        data-test-id="activitySummaryButton"
        style={{ ...navItemTileStyle, flexGrow: 0, padding: 0 }}
      >
        <Box
          // AssignmentOutlined is 24px by default (smaller than the 30px nav rows) and ignores this Box's size, so the '& svg' rule must size the svg itself
          sx={{
            width: navIconSize,
            height: navIconSize,
            margin: '0px 8px 0px 5px',
            flexShrink: 0,
            '& svg': { width: navIconSize, height: navIconSize },
          }}
        >
          <Badge
            color="error"
            badgeContent={badgeContent}
            overlap="rectangular"
            max={999}
            invisible={badgeContent === 0}
            sx={{
              [`& .${badgeStyles.badge}`]: {
                right: `14.3px`,
                top: '-14px',
                borderRadius: '20px',
              },
            }}
          >
            <AssignmentOutlined />
          </Badge>
        </Box>
        <Typography sx={navItemTextStyle}>Activity Summary</Typography>
      </NavItem>
    </NavTooltip>
  )
}
